// import { useState, useEffect } from "react";

// const EndCustomerDetails = ({ customerId, viewMode }) => {
//   const [customerDetails, setCustomerDetails] = useState(null);
//   const [showDetails, setShowDetails] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     let timeoutId;
//     if (showDetails && customerId) {
//       timeoutId = setTimeout(() => fetchCustomerDetails(customerId), 300); // Delay to avoid excessive calls
//     }
//     return () => clearTimeout(timeoutId);
//   }, [showDetails, customerId]);

//   const fetchCustomerDetails = async (customerId) => {
//     setLoading(true);
//     setError("");
//     try {
//       const response = await fetch(`/server/dealer_backend/contactendcustomer/${customerId}`);
//       if (!response.ok) throw new Error("Failed to fetch customer details");

//       const data = await response.json();
//       console.log(data?.data[0]);
//       setCustomerDetails(data?.data[0]);
//     } catch (error) {
//       setError("Unable to load details");
//       console.error("Error fetching customer details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="relative">
//       <h5 className={`font-lg text-gray-700 dark:text-gray-400  ${viewMode == "table" ? 'mt-[-14px]' : 'float-right mt-[-18px]'}`}>
//         {/* {customerId} */}
//         {customerId && (
//           <button
//             onMouseEnter={() => setShowDetails(true)}
//             onMouseLeave={() => setShowDetails(false)}
//             className="ml-2 h-5 w-5 border rounded flex items-center justify-center"
//           >
//             i
//           </button>
//         )}
//       </h5>

//       {showDetails && (
//         <div className="absolute bg-white p-3 shadow-lg rounded-lg w-64 top-6 left-0 border border-gray-200 z-20">
//           {loading ? (
//             <p className="text-gray-500">Loading...</p>
//           ) : error ? (
//             <p className="text-red-500">{error}</p>
//           ) : customerDetails ? (
//             <div>
//               <p><strong>Name:</strong> {customerDetails.Company_Name2}</p>
//               <p><strong>Email:</strong> {customerDetails.Email}</p>
//               <p><strong>Phone:</strong> {customerDetails.Phone}</p>
//               {/* <p><strong>Address:</strong> {customerDetails.address}</p> */}
//             </div>
//           ) : (
//             <p className="text-gray-500">No details available</p>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default EndCustomerDetails;


import React, { useState } from "react";
import useSWR from "swr";

const fetcher = async (url) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error("Failed to fetch customer details");
  const data = await response.json();
  return data?.data[0]; // Assuming data structure
};

const EndCustomerDetails = ({ customerId, viewMode }) => {
  const [showDetails, setShowDetails] = useState(false);

  const { data: customerDetails, error } = useSWR(
    customerId ? `/server/dealer_backend/contactendcustomer/${customerId}` : null,
    fetcher,
    { dedupingInterval: 60000 } // Cache data for 1 minute
  );

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setShowDetails(true)}
      onMouseLeave={() => setShowDetails(false)}
    >
      <h5 className={`font-lg text-gray-700 dark:text-gray-400 ${viewMode === "table" ? "mt-[-14px]" : "float-right mt-[-18px]"}`}>
        {customerId && (
          <button
            className="ml-2 h-5 w-5 border rounded flex items-center justify-center"
          >
            i
          </button>
        )}
      </h5>

      {customerId && showDetails && (
        <div className="absolute bg-white p-3 shadow-lg rounded-lg w-64 top-6 left-0 border border-gray-200 z-20">
          {error ? (
            <p className="text-red-500">Unable to load details</p>
          ) : !customerDetails ? (
            <p className="text-gray-500">Loading...</p>
          ) : (
            <div>
              <p><strong>Name:</strong> {customerDetails.Company_Name2}</p>
              <p><strong>Email:</strong> {customerDetails.Email}</p>
              <p><strong>Phone:</strong> {customerDetails.Phone}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EndCustomerDetails;
